import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
const DocumentTitle = require('react-document-title');
import { fetchApi } from '../../services/api';

type Props = RouteComponentProps<{ }>;

type State = {
    OldPassword: string;
    NewPassword: string;
    NewPasswordVerify: string;
}

class ChangePassword extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            OldPassword: '',
            NewPassword: '',
            NewPasswordVerify: '',
        };

        this.changePassword = this.changePassword.bind(this);
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title='Change My Password' />
            <h1>Change My Password</h1>
            <div>
                <div className="form-group">
                    <label htmlFor="oldPassword">Your Old Password</label>
                    <input
                        type="password"
                        className="form-control"
                        id="oldPassword"
                        placeholder="Old password"
                        onChange={((e) => this.setState({ OldPassword: e.target.value}))}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="newPassword">New Password</label>
                    <input
                        type="password"
                        className="form-control"
                        id="newPassword"
                        placeholder="New password"
                        autoComplete="new-password"
                        onChange={((e) => this.setState({ NewPassword: e.target.value}))}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="newPasswordVerify">Confirm New Password</label>
                    <input
                        type="password"
                        className="form-control"
                        id="newPasswordVerify"
                        placeholder="Confirm New password"
                        autoComplete="new-password"
                        onChange={((e) => this.setState({ NewPasswordVerify: e.target.value}))}
                    />
                </div>
                <button type="submit" className="btn btn-primary" onClick={this.changePassword}>Change Password</button>
            </div>
        </React.Fragment>;
    }

    private changePassword() {

        if (this.state.NewPassword != this.state.NewPasswordVerify) {
            alert("Passwords don't match!");
            return;
        }

        const data = {
            OldPassword: this.state.OldPassword,
            NewPassword: this.state.NewPassword
        };
        fetchApi('api/User/ChangePassword', data, 'POST')
            .then((response: { Succeeded: boolean, Errors: Array<{ Code: string; Description: string; }> }) => {
                if (response.Succeeded) {
                    alert("Successfully Changed Password!");
                } else {
                    alert(response.Errors[0].Description);
                }
            });
    }
}

export default ChangePassword;
